module.exports = __webpack_public_path__ + "static/media/1251.1a3ec040.jpg";